import { getRequest, patchRequest, postRequest } from 'services/requests';

const services = {
    createChat: (body) => postRequest('/chats', body),
    getChat: (chatId, params = {}) => getRequest(`/chats/${chatId}`, { params }),
    getAssignmentChatSummary: async (filter) => {
        const chats = await services.listChats(filter, { includeMessages: false });
        return chats?.[0] || null;
    },
    getSuggestions: (body) => postRequest('/chat/suggestions', body),
    listChats: (filter, options = {}) =>
        getRequest('/chats', {
            params: {
                $filter: JSON.stringify(filter),
                ...(options.includeMessages === false ? { include_messages: 'false' } : {}),
            },
        }),
    markRead: (body) => postRequest('/chat/read', body),
    pushMessage: (body) => postRequest('/chat/push-message', body),
    updateChat: (chatId, body) => patchRequest(`/chats/${chatId}`, body),
};

export default services;
